import { EuroCircleOutlined } from '@ant-design/icons'
import { Col, Empty, Row, Space } from 'antd'
import { GenericObject, RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import React from 'react'

import { MemberProps } from '../convention'

const PriceListEmpty: React.FC<MemberProps<IPriceList>> = () => {
  const { tComponent } = ToolBox.useString()
  const translate = (id: string, values?: GenericObject<React.ReactNode>) =>
    tComponent({
      recordType: RecordType.price_list,
      componentName: 'empty',
      componentType: 'core',
      id,
      values
    })

  return (
    <Empty
      image={
        <Space direction="horizontal">
          <EuroCircleOutlined style={{ fontSize: 30 }} className="text-primary" />
          <h4 className="mb-0">{translate('special_price')}</h4>
        </Space>
      }
      imageStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      description={
        <Row>
          <Col xs={{ span: 20, offset: 2 }} md={{ span: 12, offset: 6 }}>
            <p>
              {translate('description', {
                email: <a href="mailto:preisliste@klarx.com">preisliste@klarx.com</a>
              })}
            </p>
          </Col>
        </Row>
      }
    />
  )
}

export default PriceListEmpty
